//@flow

import * as React from 'react';

import useUrlResolvedClientId from './useUrlResolvedClientId';
import ResolvedClientIdContext from './ResolvedClientIdContext';

type Props = {
    children: React.Node
};

const ResolvedClientIdProvider = ({ children }: Props): React.Node => {
    const {
        clientIdFromHostName,
        clientIdFromQuery,
        localResolvedClientId,
        providerId
    } = useUrlResolvedClientId();

    const value = React.useMemo(() => {
        return {
            clientIdFromHostName,
            clientIdFromQuery,
            localResolvedClientId,
            providerId
        };
    }, [
        clientIdFromHostName,
        clientIdFromQuery,
        localResolvedClientId,
        providerId
    ]);
    return (
        <ResolvedClientIdContext.Provider value={value}>
            {children}
        </ResolvedClientIdContext.Provider>
    );
};

export default ResolvedClientIdProvider;
